module.exports = __webpack_public_path__ + "static/media/brSetting.ede5b652.png";